import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { cn } from "../lib/utils.js";
import { cva } from "class-variance-authority";
const cardVariants = cva("text-card-foreground flex flex-col gap-6 border border py-6 group rounded-xl has-[[data-slot=card-header]_[data-slot=tabs-list]]:pt-0", {
    variants: {
        variant: {
            default: "bg-card",
            surface: "bg-surface",
        },
        size: {
            default: "py-6",
            sm: "py-4",
            xs: "py-3 gap-3",
        }
    },
    defaultVariants: {
        variant: "default",
        size: "default",
    },
});
function Card({ className, variant, size, ...props }) {
    return (_jsx("div", { "data-slot": "card", "data-size": size, "data-variant": variant, className: cn(cardVariants({ variant, size }), className), ...props }));
}
function CardHeader({ className, ...props }) {
    return (_jsx("div", { "data-slot": "card-header", className: cn("@container/card-header grid auto-rows-min items-start gap-1.5 px-6 has-data-[slot=card-action]:grid-cols-[1fr_auto] [.border-b]:pb-6 group-data-[size=sm]:px-4 group-data-[size=xs]:px-3 has-[[data-slot=tabs-list]]:bg-gray-100 has-[[data-slot=tabs-list]]:border-b has-[[data-slot=tabs-list]]:px-0 rounded-t-xl", className), ...props }));
}
function CardTitle({ className, ...props }) {
    return (_jsx("div", { "data-slot": "card-title", className: cn("leading-none font-bold group-data-[size=xs]:text-sm flex items-baseline gap-2 [&_svg]:size-4 [&_svg]:relative [&_svg]:top-0.5", className), ...props }));
}
function CardDescription({ className, ...props }) {
    return (_jsx("div", { "data-slot": "card-description", className: cn("text-muted-foreground", className), ...props }));
}
function CardAction({ className, ...props }) {
    return (_jsx("div", { "data-slot": "card-action", className: cn("col-start-2 row-start-1 self-start justify-self-end h-0 flex items-center self-center", className), ...props }));
}
function CardContent({ className, ...props }) {
    return (_jsx("div", { "data-slot": "card-content", className: cn("px-6 group-data-[size=sm]:px-4 group-data-[size=xs]:px-3", className), ...props }));
}
function CardFooter({ className, ...props }) {
    return (_jsx("div", { "data-slot": "card-footer", className: cn("flex items-center px-6 [.border-t]:pt-6 group-data-[size=sm]:px-4 group-data-[size=xs]:px-3", className), ...props }));
}
export { Card, CardHeader, CardAction, CardTitle, CardDescription, CardContent, CardFooter, };
//# sourceMappingURL=Card.js.map